import React, { Component } from 'react';
import './App.css';

import { getRandomInt } from './utils'

import Grid from './components/Grid'
import Pawns from './components/Pawns'
import Graph from './components/Graph'


type Enemies = {
  [color: string]: number
}

type Props = {
  startingHealth: number,
  mode: 'capture' | 'kill' | 'capture',
  movement: 'random' | 'directional',
  squares: number,
  startingHealth: number,
  starvation: boolean,
  enemies: Enemies
}

class App extends Component<Props> {
  props: Props
  state = {
    mode: 'capture', // 'kill' | 'capture'
    movement: 'directional', // 'random' | 'directional'
    speed: 200,
    ticks: 0,
    size: 500,
    squares: 20,
    enemies: {
      red: 20,
      green: 20,
      blue: 20
    },
    grid: [],
    pawns: [],
    graph: [],
    max: 0,
    done: false,
    startingHealth: 50,
    starvation: false
  }

  ticker = null

  build() {
    const grid = []
    const openPositions = []
    const pawns = []
    const enemies = this.state.enemies

    // generate grid
    for (let row = 0; row < this.state.squares; row++) {
      const rowObj = {
        row,
        columns: []
      }
      for (let column = 0; column < this.state.squares; column++) {
        rowObj.columns.push({
          column
        })
        openPositions.push({
          row,
          column
        })
      }
      grid.push(rowObj)
    }

    for (let enemyId in this.state.enemies) {
      for (let enemy = 0; enemy < this.state.enemies[enemyId]; enemy++) {
        const position = openPositions.splice(getRandomInt(0, openPositions.length - 1), 1)[0]
        if (openPositions.length) {
          pawns.push({
            id: pawns.length,
            color: enemyId,
            alive: true,
            health: this.state.startingHealth,
            direction: getRandomInt(1, 8),
            ...position
          })
        }
      }
    }


    this.setState({
      enemies,
      grid,
      pawns,
      graph: [],
      max: Math.max(...Object.values(this.state.enemies)),
      done: false
    }, () => {
      this.tick()
    })
  }

  getNewPositionFromDirection = (pawn) => {
    if (pawn.direction === 1) {
      return {
        column: pawn.column + 1,
        row: pawn.row - 1
      }
    } else if (pawn.direction === 2) {
      return {
        column: pawn.column + 1,
        row: pawn.row
      }
    } else if (pawn.direction === 3) {
      return {
        column: pawn.column + 1,
        row: pawn.row + 1
      }
    } else if (pawn.direction === 4) {
      return {
        column: pawn.column,
        row: pawn.row + 1
      }
    } else if (pawn.direction === 5) {
      return {
        column: pawn.column - 1,
        row: pawn.row + 1
      }
    } else if (pawn.direction === 6) {
      return {
        column: pawn.column - 1,
        row: pawn.row
      }
    } else if (pawn.direction === 7) {
      return {
        column: pawn.column - 1,
        row: pawn.row - 1
      }
    } else if (pawn.direction === 8) {
      return {
        column: pawn.column,
        row: pawn.row - 1
      }
    }
  }

  movePawn = (pawn) => {
    let newPos = {
      row: 0,
      column: 0
    }

    if (this.state.movement === 'directional') {
      newPos = this.getNewPositionFromDirection(pawn)

      if (
        newPos.column < 0 ||
        newPos.column >= this.state.squares
      ) {
        pawn.direction = 8 - pawn.direction
      }
      if (newPos.row < 0) {
        if (pawn.direction === 7) {
          pawn.direction = 5
        } else if (pawn.direction === 8) {
          pawn.direction = 4
        } else if (pawn.direction === 1) {
          pawn.direction = 3
        }
      } else if (newPos.row >= this.state.squares) {
        if (pawn.direction === 5) {
          pawn.direction = 7
        } else if (pawn.direction === 4) {
          pawn.direction = 8
        } else if (pawn.direction === 3) {
          pawn.direction = 1
        }
      }

      newPos = this.getNewPositionFromDirection(pawn)
    } else {
      newPos = {
        row: (pawn.row - 1) + getRandomInt(0,2),
        column: (pawn.column - 1) + getRandomInt(0,2)
      }

      if (newPos.column < 0) { newPos.column = 1 }
      else if (newPos.column >= this.state.squares) { newPos.column = this.state.squares - 2 }
      else if (newPos.row < 0) { newPos.row = 1 }
      else if (newPos.row >= this.state.squares) { newPos.row = this.state.squares - 2 }
    }

    return {
      ...pawn,
      ...newPos
    }
  }

  agePawn = (pawn) => {
    return {
      ...pawn,
      health: pawn.health - 1,
      alive: pawn.health > 0
    }
  }

  tick = () => {
    let pawns = this.state.pawns
    let graph = [].concat(this.state.graph)
    let tick = {}

    // Move pawns
    pawns = pawns.map((pawn) => pawn.alive ? this.movePawn(pawn) : pawn)

    // Age pawns
    if (this.state.starvation) {
      pawns = pawns.map((pawn) => pawn.alive ? this.agePawn(pawn) : pawn)
    }

    // Attack pawns
    const enemiesIds = Object.keys(this.state.enemies)
    enemiesIds.map((enemyId, i) => {
      const predator = enemyId
      const prey = (i < enemiesIds.length - 1) ? enemiesIds[i + 1] : enemiesIds[0]

      // check if prey exists
      const aliveAmount = pawns.filter((predatorPawn) => (
        predatorPawn.alive &&
        predatorPawn.color === predator
      )).length
      tick[predator] = aliveAmount

      const hasAnyPrey = pawns.find((preyPawn) => (
        preyPawn.alive &&
        preyPawn.color === prey
      ))

      if (aliveAmount) {
        if (hasAnyPrey) {
          pawns.map((predatorPawn) => {
            if (predatorPawn.alive && predatorPawn.color === predator) {
              const hasPrey = pawns.find((preyPawn) => (
                preyPawn.alive &&
                preyPawn.color === prey &&
                preyPawn.row === predatorPawn.row &&
                preyPawn.column === predatorPawn.column
              ))
              if (hasPrey) {
                if (this.state.mode === 'kill') {
                  pawns[hasPrey.id].alive = false
                } else {
                  pawns[hasPrey.id].color = predator
                  pawns[hasPrey.id].health = this.state.startingHealth
                }
              }
            }
            return false
          })
        } else if (!this.state.starvation) { // if not, slowly die out
          console.log(`${prey} is gone, ${predator} will soon die.`)
          pawns.map((predatorPawn) => {
            if (
              predatorPawn.color === predator &&
              predatorPawn.alive
            ) {
              pawns[predatorPawn.id].health = pawns[predatorPawn.id].health - getRandomInt(1,3)
              pawns[predatorPawn.id].alive = pawns[predatorPawn.id].health > 0
            }
            return false
          })
        }
      }

      return false
    })

    graph.push(tick)

    const max = Math.max(...Object.values(tick), this.state.max)

    this.setState({ pawns, graph, max }, () => {
      clearTimeout(this.ticker)
      if (Math.max(...Object.values(tick)) > 0) {
        this.ticker = setTimeout(this.tick, this.state.speed)
      } else {
        this.setState({ done: true })
      }
    })
  }

  componentWillMount() {
    this.build()
  }

  componentDidUpdate(oldProp) {
    if (
      oldProp !== this.props
    ) {
      this.setState(this.props, () => {
        this.build()
      })
    }
  }

  render() {
    const containerWidth = {
      width: `${this.state.size}px`
    }

    const containerStyle = {
      ...containerWidth,
      height: `${this.state.size}px`
    }

    return (
      <div className='App'>
        <div className='container' style={containerStyle}>
          <Grid data={this.state.grid} size={this.state.size}/>
          <Pawns pawns={this.state.pawns} size={this.state.size} squares={this.state.squares} speed={this.state.speed}/>
        </div>
        <div>
          <Graph data={this.state.done ? this.state.graph : this.state.graph.slice(-50)} size={this.state.size} max={this.state.max}/>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js